import React from "react";

import { withTranslation } from "react-i18next";

import Title from "../../Structure/logo";
import Shows from "./Shows/Shows";

function Tarif(props) {
  return (
    <div>
      <div className="component-body">
        <Title icon="dollar" text="fare management" />
        {(localStorage.getItem('perm_admin') === "true" || localStorage.getItem('perm_SPV') === "true") &&
          <Shows />
        }
      </div>
    </div >
  );
}

export default withTranslation()(Tarif);
